import * as React from "react";

import { cn } from "@/lib/utils";

interface ShimmerTextProps extends React.HTMLAttributes<HTMLSpanElement> {
  children: React.ReactNode;
}

/**
 * Muted text with a sweeping band of ink, for "working on it" states.
 * The sweep is CSS-only and is skipped under prefers-reduced-motion.
 */
const ShimmerText = React.forwardRef<HTMLSpanElement, ShimmerTextProps>(
  ({ className, children, ...props }, ref) => (
    <span ref={ref} className={cn("shimmer-text", className)} {...props}>
      {children}
    </span>
  ),
);
ShimmerText.displayName = "ShimmerText";

export { ShimmerText };
